export const RECOMMEND_RATING = [
  { label: 'แนะนำต่อ', value: '10' },
  { label: 'เฉย ๆ', value: '7' },
  { label: 'ไม่แนะนำ', value: '0' },
];

export const EXPECTATION_RATING = [
  { label: 'ดีเกินความคาดหวังมาก', value: '5' },
  { label: 'ดีเกินความคาดหวัง', value: '4' },
  { label: 'ตรงตามที่คาดหวัง', value: '3' },
  { label: 'ไม่ค่อยตรงความคาดหวัง', value: '2' },
  { label: 'ไม่ตรงความคาดหวังเลย', value: '1' },
];
